module.exports = __webpack_public_path__ + "img/deskshelf12.f87ea642.jpg";